import React, {Component} from 'react'
import TextField from "@material-ui/core/TextField/TextField";
import CardContent from "@material-ui/core/CardContent";
import {ACTION_TYPES, actions} from "../../actions";
import MenuItem from "@material-ui/core/MenuItem";
import _ from 'lodash';
import {connect} from "react-redux";

class AssessmentsFilter extends Component{
    constructor(props){
        super(props);
        this.state = {
            department: {name:''},
            program: {name:''},
            college:{name:''},
            selection:'',
        }
    }

    async getFilteredAssessments(){
        const page = this.props.form.page+1
        const allAssessmentsQuery = {page:page,limit:this.props.form.limit};
        if(this.props.form.selection){
            switch(this.props.form.selection){
                case("college"):
                    const collegeQuery = {page:page,limit:this.props.form.limit,fetchId:this.props.form.college.id, fetchName:this.props.form.college.name, filterBy:'college'};
                    if(this.state.college.name == 'All Colleges'){
                        this.props.fetchAllAssessments(allAssessmentsQuery);
                    }else{
                       this.props.fetchFilteredAssessments(collegeQuery);
                    }
                    break;
                case("department"):
                    const departmentQuery = {page:page,limit:this.props.form.limit,fetchId:this.props.form.department.id, fetchName:this.props.form.department.name, filterBy:'department'};
                    if(this.state.department.name == 'All Departments'){
                        this.props.fetchFilteredAssessments(collegeQuery);
                    }else{
                        this.props.fetchFilteredAssessments(departmentQuery);
                    }
                    break;
                case('program'):
                    const programQuery = {page:page,limit:this.props.form.limit,fetchId:this.props.form.program.id, fetchName:this.props.form.program.name, filterBy:'program'};
                    if(this.state.program.name == 'All Programs'){
                        this.props.fetchFilteredAssessments(departmentQuery);
                    }else{
                        this.props.fetchFilteredAssessments(programQuery);
                    }
                    break;
                case('search'):
                    this.props.fetchFilteredAssessments({page:page, limit:this.props.form.limit, fetchName:this.props.form.searchQuery})
                    break;
                default:
                    this.props.fetchAllAssessments(allAssessmentsQuery);
            }
        }else{
            await this.props.fetchAllAssessments(allAssessmentsQuery);
        }
    }

    async componentDidUpdate(prevProps, prevState){
        if(!_.isEqual(this.state.form, this.props.form)){
            this.setState({form:this.props.form});
            await this.getFilteredAssessments()
        }
    }

    handleChange = (name) => async (event) => {
        const query = event.nativeEvent.target.getAttribute('data-key');

        switch(name) {
            case 'college':
                await this.props.fetchDepartments(query);
                const department = this.filterList('All Departments',this.props.departments);
                if(department) {
                    await this.setState({department: department});
                    await this.props.fetchPrograms(department.id);
                }
                break;
            case 'department':
                await this.props.fetchPrograms(query);
                const program = this.filterList('All Programs', this.props.programs);
                if(program) {
                    await this.setState({program: program});
                }
                break;
            case'program':
                await this.props.fetchOutcomes(query);
        }
        this.setState({
            [name]: {
                name: event.target.value,
                id: query
            },
            selection:name,
        }, ()=> {
            this.props.setNewFields({
                    type: ACTION_TYPES.SET_FIELDS.SET_FILTER_INPUTS,
                    payload: {...this.props.form,...this.state, searchQuery:'',page:0}
                })
            }
        );
        this.getFilteredAssessments();
    };

    renderList(list) {
        return _.map(list, option => {
            return (
                <MenuItem key={option.id} data-key={option.id} value={option.name} style={{width:'250'}}>
                    {option.name}
                </MenuItem>
            );
        });
    }

    filterList(nameToAdd,list) {
        list.unshift({id:'unsearchable',name:nameToAdd});
        if(list && list.length > 0) {
            return list[0];
        }
        return null;
    }

    async componentDidMount() {
        console.log('component mount assessents filter')
        this.getFilteredAssessments();
        if(!this.props.form.selection){
            await this.props.fetchColleges();
            let college = this.filterList('All Colleges',this.props.colleges);
            this.setState({college: college});
        }
    }

    render(){
        return(
            <div style={{width:'50%', display:'inline-flex'}}>
                <CardContent>
                    <div>
                        <TextField id="select-college" select label="Select College" style={{width:'400px'}} value={this.props.form.college?this.props.form.college.name:this.state.college.name} onChange={this.handleChange('college')} margin="normal">
                            {this.renderList(this.props.colleges)}
                        </TextField>
                    </div>
                    <div>
                        <TextField id="select-department" select label="Select Department" style={{width:'400px'}} value={this.props.form.department?this.props.form.department.name:this.state.department.name} onChange={this.handleChange('department')} margin="normal">
                            {this.renderList(this.props.departments)}
                        </TextField>
                    </div>

                    <div>
                        <TextField id="select-program" select label="Select Program" style={{width:'400px'}} value={this.props.form.program?this.props.form.program.name:this.state.program.name} onChange={this.handleChange('program')} margin="normal">
                            {this.renderList(this.props.programs)}
                        </TextField>
                    </div>
                </CardContent>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        user: state.user,
        colleges: state.colleges, departments: state.departments, outcomes: state.outcomes, programs: state.programs,
        form:state.filteredAssessmentsForm,
    };
}

export default connect(mapStateToProps,actions)(AssessmentsFilter);
